function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.08611 1.65C2.70523 1.65 2.33995 1.8013 2.07063 2.07063C1.8013 2.33995 1.65 2.70523 1.65 3.08611V19.1833L4.76386 16.0694C4.91858 15.9147 5.12842 15.8278 5.34722 15.8278H18.9139C19.2948 15.8278 19.66 15.6765 19.9294 15.4072C20.1987 15.1378 20.35 14.7725 20.35 14.3917V3.08611C20.35 2.70523 20.1987 2.33995 19.9294 2.07063C19.66 1.8013 19.2948 1.65 18.9139 1.65H3.08611ZM0.903901 0.903901C1.48266 0.325143 2.26762 0 3.08611 0H18.9139C19.7324 0 20.5173 0.325143 21.0961 0.903901C21.6749 1.48266 22 2.26762 22 3.08611V14.3917C22 15.2102 21.6749 15.9951 21.0961 16.5739C20.5173 17.1526 19.7324 17.4778 18.9139 17.4778H5.68895L1.40836 21.7584C1.17241 21.9943 0.817568 22.0649 0.509286 21.9372C0.201005 21.8095 0 21.5087 0 21.175V3.08611C0 2.26762 0.325143 1.48266 0.903901 0.903901Z",
  fill: "#410BF6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.3772 6.08209C4.3772 5.7024 4.685 5.39459 5.0647 5.39459H9.98261C10.3623 5.39459 10.6701 5.7024 10.6701 6.08209C10.6701 6.46179 10.3623 6.76959 9.98261 6.76959H5.0647C4.685 6.76959 4.3772 6.46179 4.3772 6.08209Z",
  fill: "#8EE267"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.54663 11.0001C4.54663 10.6204 4.85444 10.3126 5.23413 10.3126H17.4441C17.8238 10.3126 18.1316 10.6204 18.1316 11.0001C18.1316 11.3798 17.8238 11.6876 17.4441 11.6876H5.23413C4.85444 11.6876 4.54663 11.3798 4.54663 11.0001Z",
  fill: "#8EE267"
});

function SvgColorChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorChat);
export default __webpack_public_path__ + "static/media/color-chat.444d6a07.svg";
export { ForwardRef as ReactComponent };